import React from "react";
import {Col, Row, Skeleton, Space} from "antd";
import {CalendarOutlined, UserOutlined} from "@ant-design/icons";
import {Blog} from "interfaces";
import dateFormat from "dateformat";
import Side from "./list";

interface Props {
    isLoading : boolean,
    datasource : Blog
}

const Detail : React.FC<Props> = ({isLoading, datasource}) => {

    return (
        <div className={"public-container"}>
            <div className={"main-detail"}>
                <Row gutter={[50, 50]}>
                    <Col lg={17}  md={17} sm={24} xs={24}>
                        <div className={"detail-header"}>
                            <div className={"cover"}>
                                { isLoading ? <Skeleton.Avatar size={1000} shape={"square"} active={true} /> : <img src={datasource?.image?.url} alt={datasource.title}/>}
                            </div>
                            { isLoading ? <Skeleton active={true}  paragraph={{rows : 0}}  /> : <h1>{datasource.title}</h1> }
                            <Space>
                                <div>
                                    <p><UserOutlined /> WASD Labs</p>
                                </div>
                                <div>
                                    <p>
                                        <CalendarOutlined /> {datasource?.timestamp && dateFormat( new Date(datasource?.timestamp?.toDate()), "dd mmmm yyyy")}
                                    </p>
                                </div>
                            </Space>
                        </div>
                        <div className={"detail-content"}>
                            { isLoading ? <Skeleton active={true} title={false} paragraph={{rows : 50}}  /> : <div dangerouslySetInnerHTML={{__html : datasource.content}} /> }
                        </div>
                    </Col>
                    <Col lg={7} md={7} sm={24} xs={24}>
                        <Side />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default React.memo(Detail)